import { getChannelClient } from 'src/utils/messages/singleton'

// Wires the `#backToSearch` button (rendered conditionally by
// _back_to_search.html.erb when params[:back_to_search] is set) to one
// of two behaviors, decided server-side:
//
// - data-back-url present → button is a navigation control; clicking
//   replaces the current location with that URL. The dedicated
//   plg-search-to-donate widget (path 3 in the S&D ecosystem) uses
//   this path.
//
// - data-back-url absent → button posts the cleared-selection signal
//   to our embed script via the channel. The auto-routing
//   plg-search + data-search-to-donate flow (path 2) uses this path,
//   and searchToDonate.js on the embed-script side reacts by removing
//   the donate iframe it spawned and showing the search widget again.
const init = () => {
  const button = document.getElementById('backToSearch')
  if (!button) return

  button.addEventListener('click', () => {
    const url = button.dataset.backUrl
    if (url) location.replace(url)
    else getChannelClient().send('searchToDonateOrganizationCleared')
  })
}

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', init)
else
  init()
